

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('path', {"id":"svg-messageProcessing-1RQZw78","d":"M13.1835 12.0001C13.4391 11.5 13.5833 10.9335 13.5833 10.3334C13.5833 8.30835 11.9417 6.66673 9.91667 6.66673C7.89162 6.66673 6.25 8.30835 6.25 10.3334C6.25 12.3584 7.89162 14.0001 9.91667 14.0001L14.25 14.0001C14.25 14.0001 13.5833 13.3334 13.1929 12.0195M12.8166 8.00006C12.8822 7.67695 12.9167 7.34253 12.9167 7.00006C12.9167 4.23864 10.6781 2.00006 7.91667 2.00006C5.15524 2.00006 2.91667 4.23864 2.91667 7.00006C2.91667 7.58445 3.01692 8.14543 3.20118 8.66673C3.91732 10.6745 2.25 12.0001 2.25 12.0001H6.58333","stroke":"currentColor","stroke-width":"1.33333","stroke-linecap":"round","stroke-linejoin":"round"}, []), "\n"]);
};

        